var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "Card",
    {
      staticClass: "p-4",
      scopedSlots: _vm._u([
        {
          key: "footer",
          fn: function () {
            return [
              _vm.notificationsDisabled
                ? _c("NotificationOffIcon", {
                    staticClass: "w-6 h-6 text-gray-800",
                  })
                : _vm._e(),
              _c("CompanyNotificationsButton", {
                staticClass: "ml-auto",
                attrs: {
                  buttonVariant: "linkButton",
                  companyId: _vm.companyId,
                  currentUserId: _vm.currentUserId,
                },
                model: {
                  value: _vm.notificationsDisabled,
                  callback: function ($$v) {
                    _vm.notificationsDisabled = $$v
                  },
                  expression: "notificationsDisabled",
                },
              }),
              _c(
                "ColorIconContainer",
                {
                  staticClass: "ml-4 mt-0.5",
                  attrs: { iconStyle: "" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("message")
                    },
                  },
                },
                [_c("ChatIcon")],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "div",
        { staticClass: "flex flex-col w-full" },
        [
          _c(
            "div",
            { staticClass: "flex" },
            [
              _c(
                "RouterLink",
                {
                  staticClass: "flex items-center",
                  attrs: {
                    to: {
                      name: _vm.routeNames.NETWORK_COMPANY,
                      params: { id: _vm.companyId },
                    },
                  },
                },
                [
                  _c("CircleWithInitials", {
                    staticClass: "mr-2",
                    attrs: {
                      disableTooltip: "",
                      title: _vm.companyName,
                      avatar: _vm.avatar,
                      id: _vm.companyId,
                      route: _vm.routeNames.NETWORK_COMPANY,
                    },
                  }),
                  _c("div", [
                    _c(
                      "p",
                      {
                        staticClass:
                          "font-bold text-base hover:text-primary-500 mb-2",
                      },
                      [_vm._v(_vm._s(_vm.companyName))]
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "flex w-full pl-10 flex-wrap -mt-1" }, [
            _c(
              "div",
              {
                staticClass:
                  "flex flex-col w-64 flex-none mr-12 xlLabelContainer",
              },
              [
                _c("CardBodyItem", {
                  attrs: { label: "Phone Number", content: _vm.phoneNumber },
                }),
                _c("CardBodyItem", { attrs: { label: "Website" } }, [
                  _vm.website
                    ? _c("span", { staticClass: "text-sm font-semibold" }, [
                        _c("a", { attrs: { href: _vm.website } }, [
                          _vm._v(_vm._s(_vm.website)),
                        ]),
                      ])
                    : _vm._e(),
                ]),
                _c("CardBodyItem", {
                  attrs: { label: "Industry", content: _vm.industry },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "flex flex-1 flex-col" },
              [
                _c("CardBodyItem", {
                  attrs: { label: "Country", content: _vm.country, wide: "" },
                }),
                _c("CardBodyItem", {
                  attrs: { label: "Сity", content: _vm.city, wide: "" },
                }),
                _c("CardBodyItem", {
                  attrs: { label: "Address", content: _vm.address, wide: "" },
                }),
              ],
              1
            ),
          ]),
          _c(
            "CardBodyItem",
            {
              staticClass: "pl-10",
              attrs: { label: "Description", labelClass: "w-24", wide: "" },
            },
            [
              _c("CollapsibleDescription", {
                attrs: { description: _vm.description },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }